import { render, staticRenderFns } from "./PartnerAffiliation.vue?vue&type=template&id=53689c63&scoped=true"
import script from "./PartnerAffiliation.vue?vue&type=script&lang=ts"
export * from "./PartnerAffiliation.vue?vue&type=script&lang=ts"
import style0 from "./PartnerAffiliation.vue?vue&type=style&index=0&id=53689c63&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53689c63",
  null
  
)

export default component.exports